export default __webpack_public_path__ + "static/media/recruit_table_icon_7.fe6abedb.svg";